<script>
  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';

  export let order;
  export let role;
  export let is_historical_order = false;

  let details = [];

  const get_comments = () => {
    if (is_any_worker_selected()) {
      if (
        (role === 'orderer' &&
          order.status !== 'order_status_initialized' &&
          order.status !== 'order_status_cancelled_by_admin') ||
        (role === 'worker' && order.status === 'order_status_initialized')
      ) {
        let comments = [];
        if (order.applications.length > 0) {
          for (let i = 0; i < order.applications.length; i++) {
            if (order.applications[i].selected) {
              comments.push(order.applications[i].message);
            }
          }
        }
        if (comments.length === 0) {
          return null;
        }
        return comments;
      }
    }
    return null;
  };

  const get_worker_desc = () => {
    if (
      role === 'orderer' &&
      order.status !== 'order_status_initialized' &&
      order.status !== 'order_status_cancelled_by_orderer'
    ) {
      let short_desc;
      if(!!order.worker) short_desc = order.worker.basic_profile.short_description_worker;
      if(!!order.worker && !!short_desc) return short_desc;
    }
    return null;
  };

  const get_orderer_desc = () => {
    if (role === 'worker') {
      return order.orderer.basic_profile.short_description_orderer;
    }
    return null;
  };

  const get_phone_number = () => {
    if (role === 'worker' && is_any_worker_selected()) {
      return `${order.orderer.basic_profile.phone.code}${order.orderer.basic_profile.phone.number}`;
    }
    if (role === 'orderer' && is_any_worker_selected()) {
      return `${order.worker.basic_profile.phone.code}${order.worker.basic_profile.phone.number}`;
    }
    return null;
  };

  const get_email = () => {
    if (role === 'worker' && is_any_worker_selected()) {
      return order.orderer.basic_profile.email;
    }
    if (role === 'orderer' && is_any_worker_selected()) {
      return order.worker.basic_profile.email;
    }
    return null;
  };

  const is_any_worker_selected = () => {
    if (order.status !== 'order_status_initialized') {
      if (!!order.worker) {
        return true;
      }
      return false;
    }
    return false;
  };

  const load_details = () => {
    details = [
      {
        header: t9n(TS.PROFILE_PHONE_NUMBER_LABEL),
        value: get_phone_number(),
        type: 'string',
      },
      {
        header: t9n(TS.PROFILE_EMAIL_LABEL),
        value: get_email(),
        type: 'string',
      },
      // {
      //   header: t9n(TS.SETTINGS_LABEL_WORKER_TYPE),
      //   value: t9n(order.worker.worker_profile.worker_type),
      //   type: 'string',
      // },
      {
        header: t9n(TS.ORDER_DESCR_ORDERER),
        value: get_orderer_desc(),
        type: 'string',
      },
      {
        header: t9n(TS.ORDER_DESCR_WORKER),
        value: get_worker_desc(),
        type: 'string',
      },
      {
        header: t9n(TS.ORDER_WORKER_COMMS),
        value: get_comments(),
        type: 'array',
      },
    ];

    if (is_historical_order) details = details.splice(2);
  };

  $: if (order) load_details();

  // console.log('details', details);
</script>

<!-- here comes the loop -->

<div class="mdc-data-table">
  <table class="mdc-data-table__table">
    <tbody class="mdc-data-table__content">

      {#each details as item, i}
        {#if !!item.value}
          <tr class="mdc-data-table__row">
            <th class="mdc-data-table__cell">{item.header}</th>

            {#if item.type === 'string'}
              <td class="mdc-data-table__cell cell-right">
                {#if !!item.value}{item.value}{/if}
              </td>
            {/if}

            {#if item.type === 'array'}
              <td class="mdc-data-table__cell cell-right">
                {#each item.value as row, j}
                  {#if !!row}
                    {row}
                    <br />
                  {/if}
                {/each}
              </td>
            {/if}
          </tr>
        {/if}
      {/each}

    </tbody>
  </table>
</div>

<style>
  .mdc-data-table__cell {
    color: #616161;

    /*background-color: #fafafa;*/
  }

  .cell-right {
    max-width: 200px;
    word-wrap: break-word;
    white-space: normal;
  }

  .mdc-data-table {
    width: 100%;
    border: 0;
    border-radius: 0;
    overflow-x: auto;
    /*border-style: 0;*/
  }

  .mdc-data-table__row {
    /*border-top-width: 1px;*/
    border-top-style: dashed;
  }

  th {
    font-weight: 800;
    text-align: left;
    max-width: 300px;
    min-width: 150px;
    /*word-wrap: break-word;*/
    /*white-space: normal;*/
  }

  td {
    width: 100%;
    font-weight: 500;
  }
</style>
